var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSetup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.778 4.179l-6.61-3.141a.39.39 0 00-.335 0l-6.61 3.14a.388.388 0 000 .703l6.61 3.14a.384.384 0 00.334 0l6.611-3.14a.388.388 0 000-.702zM7 7.239L1.295 4.53 7 1.82l5.706 2.71L7 7.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.445 6.826l-6.314 3a.306.306 0 01-.263 0l-6.312-3a.388.388 0 10-.334.702l6.61 3.14a.384.384 0 00.334 0l6.612-3.14a.388.388 0 00-.333-.702z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.445 9.475L7 12.536.556 9.475a.39.39 0 00-.334.701l6.61 3.141a.384.384 0 00.334 0l6.612-3.14a.388.388 0 00-.333-.703z"
  })));
}
export default SvgDataSetup;